import React from "react";
import Style from "./index.module.scss";
import classNames from "classnames";

interface Props {
    title?: string;
    content: string | React.ReactChild;
    className?: string;
}
const Index = ({ title = "说明:", content, className }: Props) => {
    return (
        <dl className={classNames(Style.root, className)}>
            <dt className={Style.title}>{title}</dt>
            <dd className={Style.content}>{content}</dd>
        </dl>
    );
};

export default Index;
